import { Component, input } from "@angular/core";
import { NgStyle } from "@angular/common";
import { ParkourLoadingSpinnerComponent } from "../parkour-loading-spinner/parkour-loading-spinner.component";

@Component({
  selector: "parkour-progress",
  templateUrl: "./parkour-progress.component.html",
  standalone: true,
  imports: [NgStyle, ParkourLoadingSpinnerComponent],
})
export class ParkourProgressComponent {
  public readonly progress = input.required<"unknown" | number>();
}
